var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0645 2.5C8.19445 2.5 5.06445 5.63 5.06445 9.5C5.06445 14.75 12.0645 22.5 12.0645 22.5C12.0645 22.5 19.0645 14.75 19.0645 9.5C19.0645 5.63 15.9345 2.5 12.0645 2.5ZM7.06445 9.5C7.06445 6.74 9.30445 4.5 12.0645 4.5C14.8245 4.5 17.0645 6.74 17.0645 9.5C17.0645 12.38 14.1845 16.69 12.0645 19.38C9.98445 16.71 7.06445 12.35 7.06445 9.5Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0645 12C13.4452 12 14.5645 10.8807 14.5645 9.5C14.5645 8.11929 13.4452 7 12.0645 7C10.6837 7 9.56445 8.11929 9.56445 9.5C9.56445 10.8807 10.6837 12 12.0645 12Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.d3fa7eba6f25c46f78062e2b6d02c236.svg";
export { ForwardRef as ReactComponent };